
import React from "react";
import { useNavigate } from "react-router-dom";
import Spinner from "Common/Globle/Spinner";
import { validateForm } from "utils/validation";
import { RoomFeatureRules } from "validation/ValidationRules";
import { Create} from "adminApi/RoomFeatureApi/RoomFeature";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import fields from "../json/RoomFeatureFields.json";
import AddRoomFeaturesForm from "./Componates/AddRoomFeaturesForm";

const AddRoomFeatures = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  // Initialize form values
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  // Manage input change
  const { values, errors, handleChange, setErrors } = useFormChange(initialValues, RoomFeatureRules);


  // Form submit handler
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      return await Create({data:formValues});
    },
    (vals) => {
      const err = validateForm(vals, RoomFeatureRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Room Feature created successfully"
  );

  return (
    <>
      {(loadingSubmit) && <Spinner isSpinner={true} />}
      <AddRoomFeaturesForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
      />
    </>
  );
};

export default AddRoomFeatures;
